import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Callout, Popover, Sidebar } from '@treams/treams-ui';

import DashboardDownloadScoresOptions from './DashboardDownloadScoresOptions';

export default function DashboardDownloadScores(props: { filters: graphql.AnalyticsFilters }) {
	const { t } = useTranslation();

	const [popover, setPopover] = useState(false);

	return (
		<Popover.Target
			visible={popover}
			contents={
				<DashboardDownloadScoresOptions
					startDate={new Date(props.filters.startDate)}
					endDate={new Date(props.filters.endDate)}
					groupIDs={props.filters.groupIDs ?? undefined}
					onFinish={() => setPopover(false)}
				/>
			}
			onDismiss={() => setPopover(false)}
		>
			<Callout
				color="blue"
				mb={2}
				title={t('dashboard.sidebar.downloads.scores.callout.title')}
				description={t('dashboard.sidebar.downloads.scores.callout.description')}
			/>
			<Sidebar.Item
				icon={<DocumentIcon />}
				title={t('dashboard.sidebar.downloads.scores.title')}
				small
				onClick={() => setPopover(true)}
			/>
		</Popover.Target>
	);
}
